import React from "react";
import { Box, Typography } from "@mui/material";
import { IAttachmentFile } from "../../../../../interfaces/corporateEvent";
import AttachmentCard from "../../../../reusable-components/b2b/attachment-card/AttachmentCard";
import CorporateEventDetailListItem from "../../../../reusable-components/b2b/corporate-event-detail-list-item/corporateEventDetailListItem";
import RichHtmlNotes from "../../../../reusable-components/b2b-notes-rich-text/RichHtmlNotes";
import "./additionalInfoTabContent.scss";

interface AdditionalInfoTabContentProps {
	attachments: IAttachmentFile[];
	notes?: string | null;
}

const AdditionalInfoTabContent: React.FC<AdditionalInfoTabContentProps> = ({
	attachments = [],
	notes,
}) => {
	return (
		<Box className="additionalInfoTabContent">
			<CorporateEventDetailListItem
				title="Attachments"
				renderValue={() =>
					attachments.length > 0 ? (
						<Box className="attachmentsContainer">
							{attachments.map((attachment) => (
								<AttachmentCard key={attachment.id} attachment={attachment} />
							))}
						</Box>
					) : (
						<Typography className="value">None</Typography>
					)
				}
			/>
			<CorporateEventDetailListItem
				title="Notes"
				detailListItemClass="notesRichDetailItem"
				renderValue={() => <RichHtmlNotes html={notes} />}
			/>
		</Box>
	);
};

export default AdditionalInfoTabContent;
